import { Box, Button, Card, Stack, styled, Typography } from '@mui/material';

export const SettingBox = styled(Stack)`
  width: 100%;
  flex-direction: column;
  padding: 1.5rem 0;
  gap: 32px;
  justify-content: center;
  overflow: hidden;

  @media (max-width: 900px) {
    flex-direction: column;
    padding: 1rem 0;
    gap: 4px;
  }
`;

export const WhiteWrapper = styled(Stack)`
  background-color: white;
  padding: 1.5rem;
  border-radius: 1.5rem;
  border: 1px solid ${({ theme }) => theme.palette.neutral.otherBorder};
  flex: 1;
  max-width: 650px;

  @media (max-width: 900px) {
    padding: 1rem;
    border-radius: 1rem;
  }
`;

export const LeftSide = styled(Stack)`
  gap: 8px;
  max-width: 260px;
  width: 30%;
  @media (max-width: 900px) {
    flex-direction: column;
    padding: 1rem 0;
    width: 100%;
  }
`;

export const Subtitle = styled(Typography)`
  max-width: 220px;
  color: ${({ theme }) => theme.palette.neutral.greyFont};
`;

export const StyledCard = styled(Card)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: theme.spacing(2),
  boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)',
  maxWidth: 960,
  minWidth: 600,
  [theme.breakpoints.down('md')]: {
    minWidth: 'auto',
    width: '100%',
    padding: theme.spacing(2),
  },
}));

export const StyledButton = styled(Button)(({ theme, color = 'primary' }) => ({
  borderRadius: 20,
  padding: '8px 24px',
  textTransform: 'none',
  ...(color === 'error' && {
    color: theme.palette.error.main,
    borderColor: theme.palette.error.main,
    '&:hover': {
      borderColor: theme.palette.error.dark,
      backgroundColor: 'rgba(211, 47, 47, 0.04)',
    },
  }),
}));

export const StyledSection = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(4),
  [theme.breakpoints.down('md')]: {
    marginBottom: theme.spacing(3),
  },
}));

export const StyledLoadingContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: 400,
});

export const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 2,
  padding: 7,
  paddingLeft: 12,
  paddingRight: 12,
  borderRadius: 99,
  border: '1px solid',
  borderColor: theme.palette.neutral.otherBorder,
  justifyContent: 'space-between',
  [theme.breakpoints.down('md')]: {
    padding: 6,
    paddingLeft: 10,
    paddingRight: 10,
    fontSize: '0.875rem',
  },
}));
